function ReactDetails() {
  return (
    <>
      <p>React is a JavaScript library for building user interfaces.</p>
      <p>
        React is used to build single-page applications. React allows us to
        create reusable UI components.
      </p>
    </>
  );
}

export default ReactDetails;
